import { createSlice } from "@reduxjs/toolkit";
import { createMutationMatcher, createQueryMatcher } from "store/actionMatcher";
import { resetProfile } from "../profile/slice";

const initialState = {
  isAuth: false,
  isLoading: false,
  isInitialize: true,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.isAuth = false;
      state.isLoading = false;
      state.error = null;
    },
    clearError: (state) => {
      state.error = null;
    },
    setUser: (state, action) => {
      state.isAuth = !!action.payload;
      resetProfile();
    },
  },
  extraReducers: (builder) => {
    // Handle login state
    builder
      .addMatcher(createMutationMatcher("authApi", "login", "pending"), (state) => {
        state.error = null;
      })
      .addMatcher(createMutationMatcher("authApi", "login", "fulfilled"), (state, { payload }) => {
        state.isLoading = false;
        state.isAuth = true;
        state.error = null;
      })
      .addMatcher(createMutationMatcher("authApi", "login", "rejected"), (state, { error }) => {
        console.log("Login failed handler running:", error);
        state.isLoading = false;
        state.error = error?.data?.message || error.message || "Login failed";
      });

    // Handle logout state
    builder
      .addMatcher(createMutationMatcher("authApi", "logout", "pending"), (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(createMutationMatcher("authApi", "logout", "fulfilled"), (state) => {
        state.isLoading = false;
        state.isAuth = false;
        state.error = null;
      })
      .addMatcher(createMutationMatcher("authApi", "logout", "rejected"), (state, { error }) => {
        state.isLoading = false;
        state.error = error?.data?.message || error.message || "Logout failed";
      });

    // Handle getProfile state
    builder
      .addMatcher(createQueryMatcher("profileApi", "getProfile", "pending"), (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addMatcher(createQueryMatcher("profileApi", "getProfile", "fulfilled"), (state, { payload }) => {
        state.isLoading = false;
        state.isInitialize = false;
        state.isAuth = true;
      })
      .addMatcher(createQueryMatcher("profileApi", "getProfile", "rejected"), (state, { error }) => {
        state.isLoading = false;
        state.isInitialize = false;
        state.isAuth = false;
        state.error = error?.data?.message || error.message || "Failed to fetch profile";
      });
  },
});

export const { actions: authActions, reducer: authReducer } = authSlice;
export const { logout, clearError } = authActions;
export default authReducer;
